import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, UncontrolledPopover, PopoverBody, Badge, Container
} from "reactstrap";

import Collapse from "@kunukn/react-collapse";


import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';

import Chart from "react-google-charts";

import TrackVisibility from 'react-on-screen';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState
} from 'react-accessible-accordion';

import Drawer from '@material-ui/core/Drawer';

//import { HaushaltsNav, EbenenTyp } from './HaushaltsNavComp';
import { ProduktNavTree, EbenenTyp } from './ProduktNavTreeComp';
import { HHSummiertDoppisch } from './HHSummiertDoppischComp';
import { ImgButton } from './ImgButtonComp';

import * as Utilities from "./Utilities"

import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

const paginationoptions = {
    sizePerPageList: [{
        text: '10', value: 10
    },{
        text: '15', value: 15
    }, {
        text: '20', value: 20
    }] // A numeric array is also available. the purpose of above example is custom the text
};

type State = {
    ready: boolean,
    ebene: KSLPlusAPI.HaushaltsHiearchieDoppik | undefined,
    suchText: string,
    expandedItem: string,
    openBeschreibungen: boolean[],
    multiSelect: boolean,
    selected: string
}

type Props = {    
    hh: KSLPlusAPI.HaushaltsHiearchieDoppik,
    jahr: number,
    kunde: number,
    gemeinde: number,    
    plantyp: number,
    planstufe: number,  
    plantypvgl: number,
    planstufevgl: number,
    verwaltungsansicht: boolean,
    uhconfig: KSLPlusAPI.Uhconfig|undefined,
    settings: KSLPlusAPI.SettingsModel,        
    onSelChange: (ebeneId: string) => void,
    selected: string,
    summenTyp: number,
    isVisible: boolean
}


export class EbenenHaushaltDoppisch extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        
        
    }

    static defaultProps = {
        summenTyp: 1,
        onSelChange: (ebeneId: string) => { },
        selected: "",
        planstufevgl: 0,
        plantypvgl: 0
    }

    node: any;    
    container: any = null;

    state: State = {
        ready: false,
        expandedItem: "",
        suchText: "",
        ebene: undefined,
        openBeschreibungen: [],
        multiSelect: false,
        selected: ""
    }

    redrawCharts = () => {    
        if (this.state.selected.indexOf(',') !== -1)
            this.handleMultiSelectHHEbene([], "", this.state.selected);
        else if (this.state.ebene)
            this.handleSelectHHEbene(this.state.ebene, this.state.suchText, this.state.selected);
    }
  
    componentDidMount() {
        window.addEventListener('resize', this.redrawCharts, false);
        if (this.props.selected.indexOf(',') !== -1) {  // bei Mehrfachselektion (, im string)
            this.state.multiSelect = true;
            this.handleMultiSelectHHEbene([], "", this.state.selected);
        }
        else if ( this.state.ebene )
            this.readSummenHH(this.state.ebene);
    }

    componentDidUpdate(prevProps: Props) {


        //this.state.selected = this.props.selected;

        if (this.state.selected.indexOf(',') !== -1)    // bei Mehrfachselektion (, im string)
        {
            if (this.props.selected !== prevProps.selected) {
                this.state.multiSelect = true;
                this.handleMultiSelectHHEbene([], "", this.state.selected);
            }
        }
        else if ((prevProps.plantypvgl !== this.props.plantypvgl || prevProps.planstufevgl !== this.props.planstufevgl || prevProps.planstufe !== this.props.planstufe || prevProps.plantyp !== this.props.plantyp) && this.state.ebene) {
            this.readSummenHH(this.state.ebene);
        }

    }
    

    readFiltered = (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik) => {
        this.setState({ ebene: ebene });
        /*
        var request = new KSLPlusAPI.HaushaltSummenRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;


        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        if (this.props.isvmhh) {
            request.gruppen = [3, 9];
            request.ignorierteGruppen = [0, 1, 2, 4, 5, 6, 7, 8];
        }
        else {
            request.gruppen = [0, 1, 2, 4, 5, 6, 7, 8];
            request.ignorierteGruppen = [3, 9];
        }
        request.uaStellen = ebene.uaStellen;
        request.unterabschnitt = ebene.unterabschnitt;
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31];
        client.getFilteredHaushaltByGruppierung("", request).then((hh) => {
            ebene.filter = hh;            
            this.setState({ ebene: ebene });
            //this.setState({ ready: true });
        }).catch(Reason => {
        });
        */
    }


    readSummenHH = (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik, tries: number = 0) => {
        
        
        
        var request = new KSLPlusAPI.HaushaltSummenRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.summenTyp = this.props.summenTyp;
        request.uhConfig = this.props.uhconfig && this.props.uhconfig.id ? this.props.uhconfig.id : 0
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHousholdDoppik_Client(api);

        if (ebene && ebene.ebenenId !== undefined )
            request.ebene = ebene.ebenenId;
        
        if (this.props.plantypvgl === 0) {
            client.getHaushaltsSummeByEbene("", request).then((hh) => {
                ebene.summenHH = hh;
                this.setState({ ebene: ebene });
                //this.setState({ ready: true });
            }).catch(Reason => {
                if (tries < 3)
                    setTimeout(() => { this.readSummenHH(ebene, tries++) }, 2000);
                else
                    alert("Fehler beim Lesen des Haushalts für Betrachtung nach Ebenen!");
            });
        } else {
            client.getHaushaltsSummeVglByEbene(this.props.plantypvgl, this.props.planstufevgl, "", request).then((hh) => {
                ebene.summenHH = hh;
                this.setState({ ebene: ebene });
                //this.setState({ ready: true });
            }).catch(Reason => {
                if (tries < 3)
                    setTimeout(() => { this.readSummenHH(ebene, tries++) }, 2000);
                else
                    alert("Fehler beim Lesen des Haushalts für Betrachtung nach Ebenen!");
            });
        }
        
    }

    handleMultiSelectHHEbene = (ebenen: KSLPlusAPI.HaushaltsHiearchieDoppik[], suchtext: string, selected: string) => {
        this.setState({ selected: selected });
        var ebene = new KSLPlusAPI.HaushaltsHiearchieDoppik();        
        ebene.ebenenId = selected;
        this.readSummenHH(ebene);

    }


    handleSelectHHEbene = (ebene: KSLPlusAPI.HaushaltsHiearchieDoppik, suchtext: string, selected: string) => {                 
        this.state.selected = ebene.ebenenId ?? selected;            
        this.setState({ ebene: undefined, suchText: suchtext });
        if (!ebene.summenHH && ebene.unterEbenen )
            this.readSummenHH(ebene);
        else
            setTimeout(() => {this.setState({ ebene: ebene })}, 10);

        
        if ( ebene.id === this.props.hh.id || (this.props.hh.filter && ebene.id === this.props.hh.filter.id))
        {
            this.props.onSelChange("");            
        }
        else if ( ebene.ebenenNr !== undefined && ebene.ebenenStellen !== undefined )
        {
            //const num = Utilities.Num2Str(ebene.ebenenNr, ebene.ebenenStellen);
            this.props.onSelChange(ebene.ebenenId??"");
            
        }
        
    }

    toggleBeschreibung = (idx: number) => {        
        this.state.openBeschreibungen[idx] = !this.state.openBeschreibungen[idx];
        this.setState({ready: true});
    }
    createBeschreibungsItems = (texte: KSLPlusAPI.Texte[]|undefined) => { 
        var items: JSX.Element[] = [];
        
        
        if ( !texte )
            return items;

        var numInRow = texte.length > 4 || texte.length == 3 ? 3 : 2;
        
        for ( var i = 0; i < texte.length ; i = i + numInRow )
        {
            const idx = i / numInRow;            
            this.state.openBeschreibungen.push(false);
            var spanItems : JSX.Element[] = [];
            var colItems : JSX.Element[] = [];
            for ( var j = i; j < i+numInRow && j < texte.length; j++ )
            {
                spanItems.push(
                    <span className="kslplus-beschreibung-text" key={"bespan" + j.toString()}>{texte[j].bezeichnung}</span>
                );
                colItems.push(
                    <Col className="kslplus-beschreibung-content" key={"becol" + j.toString()}>
                            {texte[j].text}                                                      
                    </Col>
                );
            }
            items.push(
                <button
                          className={"kslplus-beschreibung-toggle" + (this.state.openBeschreibungen[idx]?" active":"")}
                                                      onClick={() => this.toggleBeschreibung(idx)}
                            key={"beb" + idx.toString()}
                        >
                          
                          {spanItems}
                          <div className="rotate90">
                            <svg
                              className={"kslplus-beschreibung-icon" + (this.state.openBeschreibungen[idx]?" expanded":"")}
                              viewBox="6 0 12 24"
                            >
                              <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12"  />
                            </svg>
                          </div>
                            
                        </button>
            );
            items.push(
                <Collapse
                            isOpen={this.state.openBeschreibungen[idx]}
                            className={"kslplus-beschreibung-collapse-gradient " + (this.state.openBeschreibungen[idx]?" active":"")}
                            key={"bec" + idx.toString()}
                        >
                        <Row>   
                        {colItems}
                        </Row>
                </Collapse>
            );
        }

        return items;
        
    }

    getInitialSelected = (ebenen: KSLPlusAPI.HaushaltsHiearchieDoppik[]) : KSLPlusAPI.HaushaltsHiearchieDoppik|undefined => {                        
        for ( var i = 0; i < ebenen.length; i++ )
        {            
            var ebene = ebenen[i];
            
            if ( !ebene.verbergen )
                return ebene;

            if ( !ebene || !ebene.unterEbenen )
                continue;
            if ( ebene.unterEbenen.length > 0 && !ebene.unterEbenen[0].unterEbenen )
            {                
                return ebene;                
            }
            else
                return this.getInitialSelected(ebene.unterEbenen);
        }        
    }


    render() {        
        
        if (this.state.selected === "" && !this.state.ebene && this.props.hh.unterEbenen) {            
            this.state.ebene = this.getInitialSelected(this.props.hh.unterEbenen);
            this.state.selected = this.state.ebene?.ebenenId ?? "";                        
        }

        var numSelected = "";
        if ( this.state.ebene == this.props.hh )
        {
            numSelected = "";
               
        }
        else if (this.state.ebene && this.state.ebene.ebenenNr !== undefined && this.state.ebene.ebenenStellen !== undefined)
        {
            numSelected = Utilities.Num2Str(this.state.ebene.ebenenNr, this.state.ebene.ebenenStellen);            
        }
        
        
        var num = this.props.selected;
        
        
        if ( this.state.ebene == this.props.hh )
            num = "";
        else if ( !num.length && this.state.ebene && this.state.ebene.ebenenNr !== undefined && this.state.ebene.ebenenStellen !== undefined)
            num = Utilities.Num2Str(this.state.ebene.ebenenNr, this.state.ebene.ebenenStellen);
        

        
        var beschreibungen = this.createBeschreibungsItems(this.state.ebene ? this.state.ebene.texte : undefined);
        
        return (    
            
            <div>

                <div className="kslplus-switch-sel">

                    {this.state.multiSelect ?
                        <ImgButton tttext="Einzelauswahl" ttPos="top" id="kslplus-single-select-ko" className="kslplus-switch-sel-button" type="radiobutton" onClick={() => {
                            this.props.hh.selected = true;
                            this.handleSelectHHEbene(this.props.hh, "", "");
                            this.setState({ multiSelect: false });
                        }} />
                        :
                        <ImgButton tttext="Mehrfachauswahl" ttPos="top" id="kslplus-single-select-ko" className="kslplus-switch-sel-button" type="checkbutton" onClick={() => {
                            this.props.hh.selected = true;
                            this.handleMultiSelectHHEbene([], "", this.state.selected + ",");
                            this.setState({ multiSelect: true });
                        }} />
                    }                    
                    <ProduktNavTree hh={this.props.hh} onSelChange={this.handleSelectHHEbene} onMultiSelChange={this.handleMultiSelectHHEbene} showNumber={true} selected={this.state.selected} typ={EbenenTyp.FreieEbenen} auswahlText="Auswahl Ebene od. Suche per Eingabe" multiSelect={this.state.multiSelect} />
                </div>
                    
              
            
            <div className="kslplus-hhcomp-content">  
            
                    <div className="kslplus-content">
                        {beschreibungen}
                                                                        
                    </div>
                    {this.state.ebene != null && !this.state.ebene.verbergen && this.state.ebene.summenHH ?
                        <HHSummiertDoppisch hh={this.state.ebene.summenHH} plantyp={this.props.plantyp} plantypvgl={this.props.plantypvgl} planstufevgl={this.props.planstufevgl} jahr={this.props.jahr} isVisible={this.props.isVisible} settings={this.props.settings} summenTyp={this.props.summenTyp} uhconfig={this.props.uhconfig} callerID={this.state.ebene.id ? this.state.ebene.id : ""} verwaltungsansicht={this.props.verwaltungsansicht} />
                        : 
                        this.state.ebene != null && !this.state.ebene.verbergen ?
                        <div className="d-flex justify-content-center"> <Spinner color="primary" /></div>:
                        null
                    }
            </div>
            </div>                      
        );
    }
}

